import React, { useEffect } from "react";
import styles from "./snackbar-notification.module.scss";

import xMark from "./x-mark.svg";
import { IconButton } from "@components/atoms/buttons/icon-button/icon-button";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { updateSnackbarNotification } from "@src/reducers/your-reducer";
import { IndicatorText } from "@components/atoms/indicator-text/indicator-text";

export const SnackbarNotification = () => {
  const dispatch = useDispatch();
  const snackbarNotification = useSelector(
    (state: RootState) => state.yourSlice.snackbarNotification,
  );

  const closeSnackbarNotification = () => {
    dispatch(
      updateSnackbarNotification({
        ...snackbarNotification,
        state: "close",
        timeOut: 2500,
      }),
    );
  };

  const displayIndicatorText = () => {
    if (snackbarNotification.type === "success") {
      return <IndicatorText text={"Success"} variant={"green"} />;
    } else if (snackbarNotification.type === "error") {
      return <IndicatorText text={"Error"} variant={"red"} />;
    } else if (snackbarNotification.type === "warning") {
      return <IndicatorText text={"Warning"} variant={"orange"} />;
    } else {
      return <IndicatorText text={"Reminder"} variant={"blue"} />;
    }
  };

  useEffect(() => {
    if (snackbarNotification.state === "open") {
      setTimeout(closeSnackbarNotification, snackbarNotification.timeOut);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [snackbarNotification.state]);

  return (
    <div
      className={`${styles["snackbar-notification"]} ${
        styles[`snackbar-notification--${snackbarNotification.state}`]
      } ${styles[`snackbar-notification--${snackbarNotification.type}`]}`}
    >
      <div className={styles["snackbar-notification__left-wrapper"]}>
        <span>{displayIndicatorText()}</span>
        <p>{snackbarNotification.text}</p>
      </div>
      <IconButton fun={closeSnackbarNotification} icon={xMark} />
    </div>
  );
};
